import { useMemo } from 'react';
import MantineTable from '../../../common/table/mantine';

const PirTable = ({ pir, loading, readOnly = false }) => {
  const columns = useMemo(
    () =>
      [
        {
          accessorKey: 'sku',
          header: 'SKU number',
        },
        {
          accessorKey: 'sku_description',
          header: 'SKU description',
        },
        !readOnly && {
          accessorKey: 'buying_country',
          header: 'Buying Country',
        },
        {
          accessorKey: 'buyer_code',
          header: 'Buyer code',
        },
        !readOnly && {
          accessorKey: 'brewer_country',
          header: 'Brewer Country',
        },
        {
          accessorKey: 'brewer_code',
          header: 'Brewer code',
        },
        {
          accessorKey: 'currency',
          header: 'Currency TP',
        },
        {
          accessorKey: 'interco_markup_out_perf_re',
          header: 'RE Markup group',
          Cell: ({
            row: {
              original: { interco_markup_out_perf },
            },
          }) => parseFloat(interco_markup_out_perf || '0').toFixed(4),
        },
        {
          accessorKey: 'interco_markup_out_perf',
          header: 'Interface markup',
          Cell: ({
            row: {
              original: { interco_markup_out_perf },
            },
          }) => parseFloat(interco_markup_out_perf || '0').toFixed(4),
        },
        {
          accessorKey: 'transfer_price',
          header: 'Transfer price',
          Cell: ({
            row: {
              original: { transfer_price },
            },
          }) => parseFloat(transfer_price || '0').toFixed(4),
        },
      ].filter((c) => c),
    [pir],
  );

  return (
    <>
      <MantineTable
        columns={columns}
        initialData={pir}
        enableRowSelection={false}
        loading={loading}
        showSelectedToggle={false}
        hideSelectColumn={true}
        showResetAll={false}
        pageSize={10}
        enableColumnFilter={false}
        enableFilters={false}
        enableExport={false}
        columnFilterDisplayMode={false}
      />
    </>
  );
};

export default PirTable;
